import { asyncScheduler } from 'rxjs';
import Collapse from 'bootstrap/js/dist/collapse';
import { Directive, AfterViewInit, OnDestroy } from '@angular/core';

import { COLLAPSED } from '../constants';
import { StopEventPropagationDirective } from './stop-event-propagation.directive';

@Directive({
  selector: '[collapse]'
})
export class ExpanderDirective extends StopEventPropagationDirective implements AfterViewInit, OnDestroy {

  expanderInstances: Collapse[] = [];
  expanderSelector: string;
  closestElementSelector = '.card-header';

  ngAfterViewInit(): void {
    asyncScheduler.schedule(() => {
      this.initExpanders();
    }, 500);
  }

  ngOnDestroy(): void {
    this.destroyExpanders();
  }

  initExpanders(): void {
    if (this.expanderSelector?.startsWith('#')) {
      const element = document.getElementById(this.expanderSelector.substr(1));
      if (element) {
        this.expanderInstances?.push(this.createCollapser(element));
      }
    }
    else {
      const elements: NodeListOf<Element> = document.querySelectorAll(this.expanderSelector);

      elements.forEach(element => {
        this.expanderInstances?.push(this.createCollapser(element));
      });
    }
  }

  destroyExpanders(): void {
    this.expanderInstances?.forEach(instance => instance.dispose());
    this.expanderInstances = [];
  }

  toggleExpander(event: Event, index = 0): void {
    this.expanderInstances[index].toggle();
    const element = (event.target as HTMLElement).closest(this.closestElementSelector);

    if (element.classList.contains(COLLAPSED)) {
      element.classList.remove(COLLAPSED);
    }
    else {
      element.classList.add(COLLAPSED);
    }
  }

  private createCollapser(element: Element): Collapse {
    return new Collapse(element, {
      toggle: false
    });
  }
}
